export function getProductUrl({
  productId,
  productName,
  locale,
  slugUrl,
}: {
  productId: string | undefined
  productName: string | undefined
  locale: Locales
  slugUrl?: string
}) {
  if ((!productId || !productName) && !slugUrl) {
    return ''
  }
  const urlPrefix = localeConfig?.[locale]?.pathPrefix ? `/${localeConfig?.[locale]?.pathPrefix}` : ''

  if (slugUrl) {
    return origin.includes('localhost') ? `${urlPrefix}/p/${slugUrl.split('/p/')[1]}` : slugUrl.replace('/en/', '/')
  }

  const productNameUrl = productName
    ?.replace(/[^-a-zA-Z0-9$\s]/g, '')
    ?.replace(/\s+/g, '-')
    ?.toLowerCase()
  const url = `${urlPrefix}/p/${productNameUrl ?? ''}-${productId}.html`
  return url
}
